import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import './OpenButton.css';

/** Shared disclosure action; the destination stays available to assistive technology. */
export default function OpenButton({ to, href, children = "Open", tone = "dark", className = "", as, ...props }) {
  const classes = `toto-open-button toto-open-button--${tone} ${className}`.trim();
  const label = props['aria-label'] || (typeof children === 'string' ? children : 'Open');
  const content = <ChevronRight size={20} strokeWidth={2} aria-hidden="true" focusable="false"/>;
  if (as === "span") return <span className={classes} {...props}>{content}</span>;
  const accessible = { 'aria-label':label, title:label, ...props };
  if (to) return <Link to={to} className={classes} {...accessible}>{content}</Link>;
  if (href) return <a href={href} className={classes} {...accessible}>{content}</a>;
  return <button type="button" className={classes} {...accessible}>{content}</button>;
}
